import React from 'react';
import Header from '../../components/Reportes/Header/Header'
import ReportesComponent from '../../components/Reportes/Reportes/Reportes'

const Reportes = () => {
    return (
      <div className= "contenedor-derecho-prefectos fade-in">
        <div>
            <Header />
        </div>
        <div>
            <ReportesComponent />
        </div>
      </div>
    );
  };
  
export default Reportes;

